import React from 'react';
import { useLocation } from 'react-router-dom';
import { PageHeader, EmptyState, StatusBadge } from '../components/ui';
import { useAuth } from '../contexts/AuthContext';
import type { Recht } from '../berechtigungen';
import { findRoute } from '../navigation/routes';
import { appRolleLabel, rollenAufzaehlung, rollenMitRecht } from '../verwaltung/rollen';

export interface KeinZugriffPageProps {
  /** Das fehlende Recht; ohne Angabe aus der Routen-Registry fuer den aktuellen Pfad. */
  recht?: Recht;
}

/**
 * Seite "Kein Zugriff" (Verbesserungsplan, Paket 2 Schritt 3): AppLayout
 * rendert sie statt der Seite, wenn der Person das Recht der Route fehlt --
 * etwa ueber ein Lesezeichen oder die Palette. Sie nennt die eigene Rolle,
 * welche Rollen die Seite sehen, und wer weiterhilft.
 */
const KeinZugriffPage: React.FC<KeinZugriffPageProps> = ({ recht }) => {
  const { pathname } = useLocation();
  const { user, ssoEnabled } = useAuth();
  const entry = findRoute(pathname);
  const noetig = recht ?? entry?.recht;
  const rollen = noetig ? rollenMitRecht(noetig) : [];
  const eigene = appRolleLabel(user);

  return (
    <div className="page-container">
      <PageHeader eyebrow={entry?.label} title="Kein Zugriff" />
      <EmptyState
        icon="lock"
        title={`Diese Seite ist ${rollenAufzaehlung(rollen)} vorbehalten.`}
        description={(
          <>
            Deine Rolle ist <StatusBadge tone={eigene.tone}>{eigene.label}</StatusBadge>. {eigene.hinweis}{' '}
            Brauchst du mehr, wende dich an die Inhaber:in deines Mandanten
            {ssoEnabled ? '; Rollen werden in Keycloak vergeben.' : '.'}
          </>
        )}
        action={{ label: 'Zur Startseite', to: '/' }}
      />
    </div>
  );
};

export default KeinZugriffPage;
